export const QUERY_PREFIX     = ""
export const MAX_SUGGESTIONS  = 5


// WEBPACK FOOTER //
// ./src/features/OrderDetails/components/DaData/constants.js